import React from "react";

// Card back used only on the Astria brand.
const AstriaCardBack: React.FC = () => (
  <img
    src="/astria-card-back.png"
    alt=""
    draggable={false}
    className="w-full h-full object-cover select-none"
  />
);

export default AstriaCardBack;
